import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  notificationsApi,
  type NotificationListQuery,
} from "../services/notificationsApi";
import { NOTIFICATIONS_UNREAD_COUNT_KEY } from "./useUnreadCount";

export const NOTIFICATIONS_LIST_KEY = ["notifications", "list"] as const;

export const useNotifications = (query: NotificationListQuery = {}) =>
  useQuery({
    queryKey: [...NOTIFICATIONS_LIST_KEY, query],
    queryFn: () => notificationsApi.list(query),
    staleTime: 30_000,
  });

export const useMarkRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationsApi.markRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: NOTIFICATIONS_UNREAD_COUNT_KEY });
      qc.invalidateQueries({ queryKey: NOTIFICATIONS_LIST_KEY });
    },
  });
};

export const useMarkAllRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: NOTIFICATIONS_UNREAD_COUNT_KEY });
      qc.invalidateQueries({ queryKey: NOTIFICATIONS_LIST_KEY });
    },
  });
};
